import React from 'react';
import Shapes01 from '../../../assets/image/shapes/shape-1.png';
import Gallery07 from '../../../assets/image/3-Innovative-Ideas-for-Community-Engagement_AI.jpg';

function Aboutone() {
  return (
    <>
      <section className="about-one-section">
        <div className="container">
          <div className="row row-gutter-y-40">
            <div className="col-lg-12 col-xl-6">
              <div className="about-one-inner">
                <div className="section-tagline">Who We Are</div>

                <h2 className="section-title">
                  Welcome to the State of GTS
                </h2>
                <p>
                  At the State of GTS, we are committed to bridging the gap between communities and the services they need. Our mission is to empower individuals, businesses, and organizations through innovative, people-first solutions that create a thriving society for all.
                </p>
                <h5 className="about-one-inner-text">
                  We stand for transparency, innovation, and community engagement, ensuring that every decision we make is focused on improving lives.
                </h5>
                <div className="row row-gutter-y-30">
                  <div className="col-xl-6 col-lg-6 col-lg-6">
                    <div className="about-one-card">
                      <div className="about-one-card-number">01</div>
                      <div className="about-one-card-content">
                        <h5>Innovating for a Better Future</h5>
                      </div>
                    </div>
                  </div>

                  <div className="col-xl-6 col-lg-6 col-lg-6">
                    <div className="about-one-card">
                      <div className="about-one-card-number">02</div>
                      <div className="about-one-card-content">
                        <h5>Building Stronger Communities</h5>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-12 col-xl-6">
              <div className="about-one-image">
                <img src={Shapes01} className="floated-image-one" alt="Decorative Shape" />
                <img src={Gallery07} alt="Community Engagement" className="img-fluid" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Aboutone;
